<template>
    <v-layout
        row
        align-center
    >
        <v-flex
            class="pa-2 ma-1"
        >
            <v-card
                class="mx-auto"
                tile
            >
                <v-card-title>Your Bookings</v-card-title>
                <v-card
                    v-for="(booking, index) in bookings"
                    :key="index"
                    class="ma-3"
                    shaped
                    color="primary"
                >
                    <v-card-title class="white--text">Appointment with</v-card-title>
                    <v-card-subtitle class="white--text">{{ getDate(booking.appointment_date) }}</v-card-subtitle>
                    <v-card-subtitle class="white--text">{{ getTime(booking.appointment_date) }}</v-card-subtitle>
                    <v-btn
                        class="ma-2"
                        rounded
                    >Reschedule
                    </v-btn>
                </v-card>
                <v-card-actions></v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from 'axios';

export default {
    name: 'my-booking',
    props: ['user', 'bookings'],
    methods: {
        details(q) {
            window.location.href = '/queue/' + q.id
        },
        getDate(d) {
            let date = new Date(d);
            let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
            return months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear()
        },
        getTime(d) {
            let time = d.split(' ')[1];
            let A = '';
            let hour = time.split(':')[0];
            let minute = time.split(':')[1];
            if (time.split(':')[0] > 12) {
                A = 'PM';
                hour = hour - 12
            }
            return hour + ':' + minute + ' ' + A
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/MyBooking.vue